import React from "react";

import * as Styles from "./styles";

interface Props {
  text: string;
}

const Divider: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Styles.Text>{props?.text}</Styles.Text>
    </Styles.Container>
  );
};

export default Divider;
